<template>
  <!-- ////////// SECTION CONTACT ////////// -->
  <section id="contact">
    <!-- <h1>Contact Section</h1> -->
    <main class="contact">
      <h1>Contact Your New Web Guy</h1>
      <div class="contact-inner-wrapper">
        <div class="contact-info">

          <div class="fade-in right-slide">
            <h3>Send A Message - <br> 
              Let's Talk About Your Ideas!</h3>
            <p>
              If you have a new project in mind or need help making your website more profitable, let’s talk about it. 
              I am more than happy to share my experience and guide you through your online marketing adventure!
            </p>
          </div>

          <div class="icons">
            <a href="mailto:dave@webdevdave.com" title="Email" class="hvr-bob">
              <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x" style="color:#E73565"></i>
                <i class="fas fa-envelope fa-stack-1x fa-inverse"></i>
              </span>
            </a>

            <a href="https://www.linkedin.com/in/webworthydesign/" target="blank" title="LinkedIn" class="hvr-bob">
              <span class="fa-stack fa-2x">
                <i class="fas fa-circle fa-stack-2x" style="color:#0e76a8"></i>
                <i class="fab fa-linkedin-in fa-stack-1x fa-inverse"></i>
              </span>
            </a>
          </div>

        </div>
        
        <!-- <form name="contact" method="post" data-netlify-honeypot="bot-field" data-netlify-recaptcha="true" data-netlify="true"> -->
        <form name="contact" method="post" data-netlify-honeypot="bot-field" data-netlify="true" autocomplete="off">
          <input type="hidden" name="form-name" value="contact">

          <div id="firstname" class="fancy-field">
            <input type="text" name="firstname" v-model="form.firstname" :class="{ 'has-value': form.firstname }" required autocomplete="nope">
            <label for="firstname"><span>First Name</span></label>
          </div>

          <div id="lastname" class="fancy-field">
            <input type="text" name="lastname" v-model="form.lastname" :class="{ 'has-value': form.lastname }" required autocomplete="nope">
            <label for="lastname"><span>Last Name</span></label>
          </div>

          <div id="company" class="fancy-field">
            <input type="text" name="company" v-model="form.company" :class="{ 'has-value': form.company }" autocomplete="nope">
            <label for="company"><span>Company</span></label>
          </div>

          <div id="email" class="fancy-field">
            <input type="email" name="email" v-model="form.email" :class="{ 'has-value': form.email }" required>
            <label for="email"><span>Email</span></label>
          </div>

          <div id="phone" class="fancy-field">
            <input type="phone" name="phone" v-model="form.phone" :class="{ 'has-value': form.phone }" autocomplete="nope">
            <label for="phone"><span>Phone</span></label>
          </div>

          <div id="message">
            <textarea name="message" rows="10" v-model="form.message" :class="{ 'has-value': form.message }" required></textarea>
            <label for="message" :class="{ 'has-value': form.message }">Message</label>
          </div>

          <!-- <div data-netlify-recaptcha="true"></div> -->
          <button id="submit">Send <img class="paper-plane" src="../assets/paper-airplane.svg" alt="Send"></button>
        </form>

      </div>
    </main>
  </section>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      form: {
        firstname: null,
        lastname: null,
        company: null,
        email: null,
        phone: null,
        message: null
      }
    };
  },
  methods: {
    /* formChange(e) {
      console.log("CHANGED!", e.target.name);
      this.firstname = true;
      console.log(this.firstname);
    } */
  },
  computed: {
    // hasText() {
    //   return !!this.form.firstname;
    // }
  }
};
</script>

<style lang="scss" scoped>
//CONTACT ///////////////

section#contact {
  // prettier-ignore
  // background: url("../assets/halftone-top-orange.png") repeat-x left top, #4f566c;
  background-color: #4f566c;
  // prettier-ignore
  background: url("../assets/halftone-top-tomato.png") repeat-x left top, 
              url("../assets/paper-airplane.png") no-repeat calc(50% - 150px) 80px,
              url("../assets/map-20.jpg") no-repeat right top, 
              #4f566c;
  // prettier-ignore
  @include tablet-down {
    background: url("../assets/halftone-top-tomato.png") repeat-x left top,
                url("../assets/paper-airplane.png") no-repeat right 50px, #4f566c;
  }
  // prettier-ignore
  @include phone-down {
    background: url("../assets/halftone-top-tomato.png") repeat-x left top,
                url("../assets/paper-airplane.png") no-repeat right 90px/150% auto, #4f566c;
  }

  .contact {
    h1 {
      line-height: 1.2;
    }
    .contact-inner-wrapper {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 25px;
      @include tablet-down {
        grid-template-columns: 1fr 1fr;
      }
      @include phone-down {
        grid-template-columns: 1fr;
      }
      .contact-info {
        display: flex;
        flex-direction: column;
        h3 {
          line-height: 1.3;
        }
        p {
          // flex: 1;
        }
        .icons {
          margin: auto 0 45px 0;
          @include phone-down {
            margin: auto 0 0 -10px;
            text-align: right;
          }
        }
      }
      form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;
        grid-template-areas:
          "fn ln"
          "co co"
          "em ph"
          "ms ms"
          ". sb";
        @include tablet-down {
          grid-template-areas:
            "fn fn"
            "ln ln"
            "co co"
            "em em"
            "ph ph"
            "ms ms"
            "sb sb";
        }
        input,
        textarea {
          font-size: 1.6rem;
          font-family: "Quicksand", sans-serif;
          // font-weight: bold;
          min-width: 100%;
          line-height: 1.2;
          color: white;
          outline: none;
          border: none;
          background: transparent;
          // background: rgba(white, 0.1);
          // border-top-left-radius: 10px;
          // border-bottom-right-radius: 10px;
        }
        > div.fancy-field {
          // background-color: red;
          overflow: hidden;
          position: relative;
          height: 50px;
          input {
            // width: 100%;
            height: 100%;
            padding-top: 20px;
            &.has-value + label > span,
            &:focus + label > span {
              transform: translateY(-150%);
              font-size: 1.4rem;
              color: $electric-blue;
            }
            &.has-value + label::after,
            &:focus + label::after {
              transform: translateX(0%);
            }
          }
          label {
            // font-family: "Oswald", sans-serif;
            color: rgba(white, 1);
            position: absolute;
            bottom: 0;
            left: 0;
            height: 100%;
            width: 100%;
            pointer-events: none;
            border-bottom: 1px solid rgba(white, 1);
            &::after {
              content: "";
              position: absolute;
              left: 0;
              bottom: -1px;
              height: 100%;
              width: 100%;
              border-bottom: 1px solid $electric-blue;
              transform: translateX(-100%);
              transition: all 0.4s ease;
            }
            span {
              position: absolute;
              bottom: 5px;
              left: 0;
              transition: all 0.4s ease;
            }
          }
        }
        #firstname {
          grid-area: fn;
        }
        #lastname {
          grid-area: ln;
        }
        #company {
          grid-area: co;
        }
        #email {
          grid-area: em;
        }
        #phone {
          grid-area: ph;
        }
        #message {
          grid-area: ms;
          padding-top: 26px;
          display: flex;
          flex-direction: column-reverse;
          label {
            color: rgba(white, 1);
            transition: all 0.4s ease;
          }
          textarea {
            margin-top: 5px;
            border: 1px solid rgba(white, 1);
            padding: 5px;
            transition: all 0.4s ease;
            &.has-value,
            &:focus {
              border: 1px solid $electric-blue;
              // outline: 1px solid $electric-blue;
              & + label {
                color: $electric-blue;
              }
            }
          }
        }
        #submit {
          grid-area: sb;
          margin-top: 15px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 10px 30px;
          border: none;
          border-top-left-radius: 20px;
          border-bottom-right-radius: 20px;
          background: rgba($almost-black, 0.5);
          color: white;
          transition: all 0.4s ease-out;
          .paper-plane {
            height: auto;
            width: 20px;
            margin-left: 10px;
            transition: all 0.4s ease-out;
          }
          &:hover {
            background: rgba($almost-black, 0.88);
            .paper-plane {
              transform: translateX(10px);
            }
          }
        }
      }
    }
  }

  /*   
  main.contact {
    padding: 150px 0 0 0;
    flex: 1;
    @include tablet-down {
      padding: 100px 0;
    }
    @include phone-down {
      padding: 50px 0 15px 0;
    }
  } 
  */
}
</style>
